import RenderHTML from './RenderHTML'
import { powerPerformanceConfig } from '../../utils/mutualFundDetail'
import { formMetaData } from '../../utils/formMetaData'
import { PowerPerformanceForms } from '../../types/mutual-fund-detail.types'

const UNRATED_FORMS: `${PowerPerformanceForms}`[] = [
  PowerPerformanceForms.NOT_RATED,
  PowerPerformanceForms.PERFORMANCE_LOCKED
]

type PowerFormBadgeProps = {
  powerForm?: `${PowerPerformanceForms}` | null
}

export function PowerFormBadge({ powerForm }: PowerFormBadgeProps) {
  if (!powerForm) return null

  if (UNRATED_FORMS.includes(powerForm)) {
    const meta = formMetaData[powerForm]
    if (!meta) return null
    return (
      <div
        className='inline-flex items-center gap-1 rounded-[8px] px-1.5 py-0.5 text-[12px] font-[500]'
        style={{ backgroundColor: meta.color, color: meta.textColor }}
      >
        {meta.label}
      </div>
    )
  }

  const badge = powerPerformanceConfig?.[powerForm]?.badge
  if (!badge) return null
  return (
    <div>
      <RenderHTML innerHTMLText={badge} />
    </div>
  )
}
